import { SignUpCard } from "../../components";

const SignUp = () => {
  return (
    <div className="mb-[60px] lg:mb-0">
      <SignUpCard />
    </div>
  );
};

export { SignUp };
